export default __webpack_public_path__ + "media/images/images/gallery/26-28e572c1da5197b55ec13cf239623332.jpg";